<template>
    <div><!-- 招標案件查詢 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('SearchBar_Vue.VendorSearchHeaderText')}}</strong>
            </CCardHeader>
            <CCardBody>
                <!-- <CNavbar light color="light"> -->
                    <CForm>
                        <div class="CForminline">
                            <div class="name">
                                <p>{{$t('SearchBar_Vue.RequestName')}}：</p>
                                <input maxlength="100" type="text" v-model="search.RequestName">
                            </div>

                            <div class="date_range">
                                <p>{{$t('SearchBar_Vue.StartDateBeginText')}}：</p>
                                <date-picker :lang="'zh-tw'" v-model="search.StartDateBegin" format="YYYY-MM-DD" valueType="format" ></date-picker>
                                <span>~</span>
                                <date-picker :lang="'zh-tw'" v-model="search.StartDateEnd" format="YYYY-MM-DD" valueType="format" :disabled-date="(date) => date <= new Date(search.StartDateBegin)" ></date-picker>
                            </div>

                            <div class="date_range">
                                <p>{{$t('SearchBar_Vue.DeadlineBeginText')}}：</p>
                                <date-picker :lang="'zh-tw'" v-model="search.DeadlineBegin" format="YYYY-MM-DD" valueType="format" ></date-picker>
                                <span>~</span>
                                <date-picker :lang="'zh-tw'" v-model="search.DeadlineEnd" format="YYYY-MM-DD" valueType="format" :disabled-date="(date) => date <= new Date(search.DeadlineBegin)" ></date-picker>
                            </div>

                            <div class="number_range">
                                <p>{{$t('SearchBar_Vue.QuoteNoIntervalText')}}：</p>
                                <input type="text" maxlength="12" v-model="search.QuoteNoBegin" @change="checkQuoteNo">
                                <span>~</span>
                                <input type="text" maxlength="12" v-model="search.QuoteNoEnd" @change="checkQuoteNo">
                            </div>

                            <div class="quotation_class">
                                <p>{{$t('SearchBar_Vue.RequestTypeText')}}：</p>
                                <div v-for="(item, key) in requestTypeList" :key="'requestType_input_' + key" >
                                    <input type="radio" name="requestType_input"
                                        v-model="search.RequestType" 
                                        :value="item.requestTypeId" />{{item.requestTypeCaption}}
                                </div>
                            </div>

                            <div class="purchase">
                                <p>{{$t('SearchBar_Vue.PurchaserText')}}：</p>
                                <Select2 style="width: 30%" class="purchase_input" v-model="search.PurchaserNo" :options="procurementOfficerList" :settings="{ 'multiple': 'true' }" />
                            </div>

                            <div class="closure">
                                <p>{{$t('SearchBar_Vue.CaseClosedText')}}：</p>
                                <div v-for="(item, key) in caseClosedList" :key="'caseClosed_input_' + key" >
                                    <input type="radio" name="caseClosed_input"
                                        v-model="search.CaseClosed" 
                                        :value="item.caseClosedId" />{{item.caseClosedCaption}}
                                </div>
                            </div>
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2"  @click="searchData">{{$t('Buttons.Query')}}</button>
                            </div>                            
                        </div>
                    </CForm>                
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
export default {
    data() {
        return {
            search: {
                StartDateBegin:'',
                StartDateEnd:'',
                DeadlineBegin:'',
                DeadlineEnd:'',
                QuoteNoBegin:'',
                QuoteNoEnd:'',
                RequestType:'',
                PurchaserNo:[],
                CaseClosed:''
            },            
            requestTypeList: this.$t('requestSearchTypeList'), //報價類別 清單
            caseClosedList: this.$t('caseClosedList') //結案否 清單
        }
    },
    watch: {        
        lang: function() {            
            this.requestTypeList = this.$t('requestSearchTypeList')
            this.caseClosedList = this.$t('caseClosedList')
        }
    },
    mounted() {      
          
    },
    computed: {    
        ...mapGetters('purchaseModule', ['procurementOfficerList','purchaseSearchObj']),    
    },
    methods: {    
        ...mapActions('purchaseModule', ['searchPurchase','getProcurementOfficers']),        
        checkQuoteNo() {
            if(this.search.QuoteNoBegin > this.search.QuoteNoEnd) {
                this.search.QuoteNoEnd = ''
            }
        },    
        checkSearchParam(){ //檢核條件
           const {StartDateBegin,StartDateEnd,DeadlineBegin,DeadlineEnd,QuoteNoBegin,QuoteNoEnd} =this.search;
           let errMsg = '';
           if(StartDateBegin && StartDateEnd){
               if(StartDateBegin>StartDateEnd){
                 errMsg='開單日期區間錯誤，起始日不得大於終止日!';
               }
           }
           if(DeadlineBegin && DeadlineEnd){
               if(DeadlineBegin>DeadlineEnd){
                 errMsg='截止日期區間錯誤，起始日不得大於終止日!';
               }
           }
           if(QuoteNoBegin && QuoteNoEnd){
               if(QuoteNoBegin>QuoteNoEnd){
                 errMsg='單號區間錯誤，起始單號不得大於終止單號!';
               }
           }
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        searchData() {            
            if(!this.checkSearchParam()){
                return;
            }
            if(!this.search.QuoteNoEnd) {                
                this.search.QuoteNoEnd = this.search.QuoteNoBegin
            }
            //須用此方式提供 語系對應功能函數
            this.search.func = (key) => this.$t(key);
            this.search.fixDate = this.fixDate;
            this.searchPurchase(this.search);            
        },
        
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .date_range, .number_range, .quotation_class, .purchase, .closure {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
        > div {
            margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
